import { status } from '../typeStatus'
import {
  InitialState,
  CouponActions,
  CouponState,
  SET_COUPON_CODE,
  COUPON_CODE_RESET,
  GET_COUPON,
  GET_COUPON_SUCCESS,
  GET_COUPON_ERROR,
} from './types'

const CouponReducer = (state: CouponState = InitialState, action: CouponActions): CouponState => {
  switch (action.type) {
    case SET_COUPON_CODE: {
      return {
        ...state,
        couponCode: action.payload,
      }
    }

    case COUPON_CODE_RESET: {
      return InitialState
    }
    case GET_COUPON: {
      return {
        ...state,
        fetchCoupon: {
          couponCode: null,
          status: status.loading,
        },
      }
    }

    case GET_COUPON_SUCCESS: {
      return {
        ...state,
        fetchCoupon: {
          couponCode: action.payload,
          status: status.success,
        },
      }
    }
    case GET_COUPON_ERROR: {
      return {
        ...state,
        fetchCoupon: {
          couponCode: null,
          status: status.error,
        },
      }
    }
    default:
      return state
  }
}

export default CouponReducer
